import { render, staticRenderFns } from "./merchantBroad.vue?vue&type=template&id=7620314a&scoped=true"
import script from "./merchantBroad.vue?vue&type=script&lang=js"
export * from "./merchantBroad.vue?vue&type=script&lang=js"
import style0 from "./merchantBroad.vue?vue&type=style&index=0&id=7620314a&prod&lang=css"
import style1 from "./merchantBroad.vue?vue&type=style&index=1&id=7620314a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7620314a",
  null
  
)

export default component.exports